import React from 'react';
import { Layers, AlertTriangle, Clock, CheckCircle2, PackageCheck } from 'lucide-react';

const ITEMS = [
  { key: 'all', label: 'Total pedidos', Icon: Layers, tone: 'text-slate-700 bg-slate-100', testId: 'kpi-total-pedidos' },
  { key: 'late', label: 'Atrasados', Icon: AlertTriangle, tone: 'text-red-600 bg-red-50', testId: 'kpi-atrasados' },
  { key: 'justo', label: 'Justos', Icon: Clock, tone: 'text-amber-600 bg-amber-50', testId: 'kpi-justos' },
  { key: 'espacio', label: 'Con espacio', Icon: CheckCircle2, tone: 'text-emerald-600 bg-emerald-50', testId: 'kpi-con-espacio' },
  { key: 'done', label: 'Terminados', Icon: PackageCheck, tone: 'text-blue-600 bg-blue-50', testId: 'kpi-terminados' },
];

export const KpiStrip = ({ counts, active, onSelect }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-6">
    {ITEMS.map(({ key, label, Icon, tone, testId }, idx) => (
      <button
        key={key}
        data-testid={testId}
        onClick={() => onSelect(key)}
        style={{ animationDelay: `${idx * 60}ms` }}
        className={`group text-left bg-white border rounded-2xl p-4 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-[box-shadow,transform,border-color] duration-200 animate-in fade-in slide-in-from-bottom-2 fill-mode-both ${active === key ? 'border-slate-900 ring-1 ring-slate-900' : 'border-slate-200'}`}
      >
        <div className="flex items-center justify-between">
          <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
          <span className={`p-1.5 rounded-lg ${tone}`}><Icon size={16} /></span>
        </div>
        <div className="mt-2 text-3xl font-bold font-mono tracking-tight text-slate-900">{counts[key] || 0}</div>
      </button>
    ))}
  </div>
);
